import React from 'react';
import { Box } from '@mui/material';
import logo from '../../assets/images/logo.png';

const Logo = () => {
  return (
    <Box className="top_logo">
      <img src={logo} width={'180px'} height="45px" />
    </Box>
  );
};

export default Logo;
